import React, { useState, useEffect } from 'react';
import { useSearchParams, useParams, useNavigate } from 'react-router-dom';
import { AdminAuthProvider } from '../../contexts/AdminAuthContext';
import AdminDashboardTabs from '../../components/ui/AdminDashboardTabs';
import AdminLoginGate from './components/AdminLoginGate';
import TemplateManagementTab from './components/TemplateManagementTab';
import AnalyticsTab from './components/AnalyticsTab';
import ContentEditorTab from './components/ContentEditorTab';
import MediaLibraryTab from './components/MediaLibraryTab';
import GuestManagementTab from './components/GuestManagementTab';
import SettingsTab from './components/SettingsTab';

const AdminDashboard = () => {
  const [searchParams] = useSearchParams();
  const { id: weddingId } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('analytics');

  useEffect(() => {
    const tabParam = searchParams?.get('tab');
    // Support legacy 'cms' parameter for backward compatibility
    const normalizedTab = tabParam === 'cms' ? 'content' : tabParam;
    if (normalizedTab && ['templates', 'analytics', 'content', 'media', 'guests', 'settings']?.includes(normalizedTab)) {
      setActiveTab(normalizedTab);
    }
  }, [searchParams]);

  const renderTabContent = () => {
    switch (activeTab) {
      case 'content':
        return <ContentEditorTab weddingId={weddingId} />;
      case 'media':
        return <MediaLibraryTab weddingId={weddingId} />;
      case 'templates':
        return <TemplateManagementTab weddingId={weddingId} />;
      case 'analytics':
        return <AnalyticsTab weddingId={weddingId} />;
      case 'guests':
        return <GuestManagementTab weddingId={weddingId} />;
      case 'settings':
        return <SettingsTab weddingId={weddingId} />;
      default:
        return <AnalyticsTab weddingId={weddingId} />;
    }
  };

  return (
    <AdminAuthProvider>
      <AdminLoginGate>
        <div className="min-h-screen bg-background">
          {/* Back to dashboard link */}
          <div className="max-w-screen-xl mx-auto px-4 md:px-6 lg:px-8 pt-4">
            <button
              onClick={() => navigate('/dashboard')}
              className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1"
            >
              <span>&larr;</span> Back to My Weddings
            </button>
          </div>
          <AdminDashboardTabs />
          <main className="max-w-screen-xl mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8 lg:py-12">
            {renderTabContent()}
          </main>
        </div>
      </AdminLoginGate>
    </AdminAuthProvider>
  );
};

export default AdminDashboard;
